<template>
  <v-select
    :return-object="false"
    :items="options"
    v-model="innerValue"
    item-text="text"
    item-value="value"
    v-bind="resetProps"
    @blur="emitBlur"
    @change="$emit('change')"
  />
</template>

<script>
export default {
  props: {
    items: Array,
    value: String
  },
  watch: {
    value(n) {
      this.innerValue = n;
    },
    innerValue(value) {
      this.$emit("input", value);
    },
  },
  computed: {
    resetProps() {
      return { ...this.$attrs };
    },
  },

  methods: {
    emitBlur() {
      this.$emit("blur");
    },
  },
  data() {
    return {
      innerValue: this.value,
      options: [
        {
          text: "Approved",
          value: "approved",
        },
        {
          text: "Rejected",
          value: "rejected",
        },
        {
          text: "Saved",
          value: "saved",
        },
        {
          text: "Sent",
          value: "sent",
        },
      ],
    };
  },
};
</script>